module.exports = __webpack_public_path__ + "static/media/g2-review-batch.37c9af2e.png";